enum EnumResultCode {
  SIGNED = 1,
  WAIT = 2,
  IGNORE = 3,
  REJECT = 4,
}

export default EnumResultCode;
